import LoadingButton from '@/common/components/base/button/loadingButton';
import TitleDescription from '@/common/components/base/typography/TitleDescription';
import FixToBottom from '@/common/components/layouts/FixToBottom';
import MainLayout from '@/common/components/layouts/MainLayout';
import useSignature from '@/common/hooks/useSignature';
import { Box } from 'styled-system/jsx';
import Typography from '@/common/components/base/typography/Typography.tsx';
import useSignatureRegisterMutation from '@/modules/Dashboard/hooks/useSignatureRegisterMutation.ts';
import { useQuery } from '@tanstack/react-query';
import { userInfoQueryOptions } from '@/common/queries/userInfo/userInfoQueryOptions.ts';
import { getAdjusterSignatureQueryOptions } from '@/modules/Dashboard/queries/sidebarSignature/getAdjusterSignatureQueryOptions.ts';
import LoadingPage from '@/common/pages/LoadingPage.tsx';
import { useNavigate } from 'react-router-dom';
import SignaturePreview from '@/common/components/base/signatureCanvas/instances/SignaturePreview.tsx';
import SignatureDrawingPad from '@/common/components/base/signatureCanvas/instances/SignatureDrawingPad.tsx';
import { ConvertUrlToFile } from '@/common/utils/ConvertUrlToFile';

export default () => (
  <MainLayout title="ثبت امضا" header="titleHeader" hasBottomPadding>
    <SidebarSignaturePage />
  </MainLayout>
);

const SidebarSignaturePage = () => {
  const navigate = useNavigate();
  const signature = useSignature();
  const { mutate, isPending } = useSignatureRegisterMutation();
  const { data: userInfo } = useQuery(userInfoQueryOptions());
  const { data, isLoading, isError } = useQuery(
    getAdjusterSignatureQueryOptions(userInfo?.has_signature!),
  );
  const generateFormData = (blob: Blob) => {
    const formData = new FormData();
    const image = ConvertUrlToFile(blob, 'image', 'image');

    formData.append('image', image);
    return formData;
  };

  const mutateOnSuccess = () => {
    navigate(-1);
  };
  const submitSignature = async () => {
    const signBlob = await signature.getImage();
    const formData = generateFormData(signBlob);
    mutate(formData as any, {
      onSuccess: mutateOnSuccess,
    });
  };
  if (isLoading) {
    return <LoadingPage />;
  }
  if (isError) {
    return <></>;
  }
  return (
    <Box pt="15px">
      <TitleDescription mb="20px">
        کارشناس محترم، ضمن حرکت دادن انگشت خود در کادر زیر امضای خود را ترسیم
        نمایید.
      </TitleDescription>
      <Typography mb="5px" textStyle="b4" color="black-2">
        ثبت امضا :
      </Typography>
      {signature.showPreviewMode && data?.image ? (
        <SignaturePreview
          exitPreviewMode={signature.exitPreviewMode}
          image={data?.image!}
        />
      ) : (
        <SignatureDrawingPad {...signature} />
      )}
      <FixToBottom>
        <LoadingButton
          onClick={submitSignature}
          disabled={signature.isEmpty}
          loading={isPending}
          fullWidth
        >
          ثبت
        </LoadingButton>
      </FixToBottom>
    </Box>
  );
};
